import { escape } from "@omnia/shared/utils/regexp";
import { FieldViewModel, ICrop } from "../../omnia"
import { IFieldsService } from "../../types"
import { IDashboardFilters } from "./types"

export class DashboardFilters implements IDashboardFilters {

    private _subset: FieldViewModel[];
    private _visible: FieldViewModel[];

    private _crop: ICrop
    private _text: string;

    private _textRegexp: RegExp;

    constructor(private svc: IFieldsService) {
        this._visible = this._subset = svc.cropping.filter(c => c.currentYear && c.visible)
    }

    reset() {
        return this.update(this._subset, null, null)
    }

    refresh() {
        return this.update(this._subset, this._crop, this._text, false)
    }

    get crop() {
        return this._crop
    }

    get text(): string {
        return this._text;
    }

    get cropping(): FieldViewModel[] {
        return this._visible;
    }

    setSubset(subset: FieldViewModel[]) {
        return this.update(subset, this._crop, this._text);
    }

    setCrop(crop: ICrop): DashboardFilters {
        return this.update(this._subset, crop, this._text);
    }

    setText(text: string): DashboardFilters {
        return this.update(this._subset, this._crop, text);
    }

    getTextRegExp(): RegExp {
        return this._textRegexp;
    }

    private update(subset: FieldViewModel[], crop: ICrop, text: string, check: boolean = true): DashboardFilters {

        if (check && (crop == this._crop) && (text == this._text) && (subset === this._subset)) {
            return this
        }

        const u = new DashboardFilters(this.svc)
        u._subset = subset
        u._crop = crop
        u._text = text
        u.applyFilters()

        return u

    }

    private applyFilters() {

        let text: RegExp;

        if (this._text) {
            text = new RegExp(escape(this._text), "i");
        }
        this._textRegexp = text;

        let cropping = (this._subset || this.svc.cropping).filter(c => c.visible && c.currentYear)

        if (this._crop) {
            cropping = cropping.filter(c => c.cropId == this._crop.CropId)
        }

        if (text) {
            cropping = cropping.filter(f => text.test(f.description))
        }

        this._visible = cropping

    }
}
